import { type Dayjs } from "dayjs";

import { AgendaView } from "./AgendaView";
import { type CalendarEventsProps, type CalendarView } from "./calendarModel";
import { MonthView } from "./MonthView";
import { WeekView } from "./WeekView";

interface CalendarViewSwitchProps<T> extends CalendarEventsProps<T> {
  view: CalendarView;
  date: Dayjs;
}

// Siatka ma minimum 840 px: węższa tnie chipy do 2-3 liter, więc na wąskim ekranie się przewija.
export const CalendarViewSwitch = <T,>({ view, ...props }: CalendarViewSwitchProps<T>) => {
  if (view === "agenda") {
    return <AgendaView {...props} />;
  }

  return (
    <div className="overflow-x-auto">
      <div className="min-w-[840px]">{view === "month" ? <MonthView {...props} /> : <WeekView {...props} />}</div>
    </div>
  );
};
